








































import { genPostReq } from "@/services/checklist.service";

export default  {
  props: ['search_keyword'], 
  data() {
    return {
      create_progress: false,
      checklist_dialog: {},
      form_data: {},
    }
  },
  watch: {
    checklist_dialog: function (val, oldVal) {
      if (!val) {
        this.$emit("dialogClosed", true);

        
      }
    },
  },
  computed: {

  },
  mounted() {
    this.create_progress = true
  },
  destroyed() {
    //console.log("destroyed")
  },
  methods: {
    closeDialog: function () {
      this.$emit("dialogClosed", true);
    },   
    save: function () {
      console.log(this.form_data)
      this.create_progress = true

      const data = {  
        projectId: this.$store.state.che_projectId, 
        form_data: this.form_data
      }

 

      genPostReq("inspect-editor", "add-result", data)
        .then(resp => {
          this.create_progress = false;
          this.$store.commit('update_results', resp.data) 
          this.closeDialog()
        })
        .catch(e => {
          //this.$store.dispatch('api_error', e)
        });


    }
     
   
  }
}

